module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BoldItalic-967f0159ab4ea606b1841cd282999516.woff";